<template >

<div v-if="logo" class="img-wrapper">
    <NuxtLink
      :to="$methods.localePath('/')"
      class="text-decoration-none"
      style="display: block; height: 100%"
      >
        <img class="pa-0 ma-0 custom-img" :alt="altText" :src="logo" />
    </NuxtLink>
  </div>
</template>

<script setup>
import { useSiteSettingsStore } from '../../store/siteSettings';

const siteSettings = useSiteSettingsStore()
const { $methods } = useNuxtApp()
let altText = siteSettings.LogoAltText;
let logo = siteSettings.Logo;

const { PUBLIC_DATA_URL } = useRuntimeConfig().public
const isDev = process.env.NODE_ENV !== 'production'

// Replace /PUBLIC with PUBLIC_DATA_URL in development environment to load icons correctly from bucket
if (isDev){
  logo = logo.replace("/PUBLIC", PUBLIC_DATA_URL)
}
</script>

<style scoped>
.img-wrapper {
height: 100%; aspect-ratio: 3.375
}

.custom-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>

